"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESEND_LIMIT = exports.FLUSH_INTERVAL = exports.FLUSH_SIZE = exports.BUFFER_SIZE = void 0;
// Default buffer constants
exports.BUFFER_SIZE = 1000;
exports.FLUSH_SIZE = 100;
exports.FLUSH_INTERVAL = 5 * 1000; // 5s
exports.RESEND_LIMIT = 5;
